export default "__VITE_ASSET__breCREYk__"